<template>
  <div id="page">
    <van-nav-bar
      title="邀请好友入团"
      left-text=""
      left-arrow
      @click-left="onClickLeft()"
    >
    </van-nav-bar>
    <!--好友搜索-->
    <van-row>
      <div style="margin-top: 10px; width: 80%; float: left;">
        <van-search v-model="tel" placeholder="请输入搜索关键词" />
      </div>
      <div
        style="width: 15%; float: left; padding-top: 20px; margin-left: 10px;"
      >
        <van-button type="primary" size="small" @click="Search">确定</van-button>
      </div>
    </van-row>
    <!--好友基本信息-->
    <van-row>
      <div style="margin-top: 10px">
        <van-form>
          <van-cell-group inset>
            <van-field
              v-model="sdworker.Name"
              name="水工姓名"
              label="水工姓名"
              readonly
            />
            <van-field
              v-model="sdworker.Tel"
              name="水工电话"
              label="水工电话"
              readonly
            />
            <div v-show="msShow">
              <van-notice-bar
                wrapable
                :scrollable="false"
                style="color:red;"
                :text="messageText"
              />
            </div>
            
            <!-- <van-field v-model="count" name="带单" label="带单" readonly /> -->
          </van-cell-group>
          <div style="margin: 16px">
            <van-button
              round
              block
              type="primary"
              :disabled="show"
              @click="CreateInvite"
            >
              确认邀请
            </van-button>
          </div>
        </van-form>
      </div>
    </van-row>
  </div>
</template>
<script>
import { NavBar, Row, Search, Button, Form, CellGroup, Field } from "vant";
export default {
  data() {
    return {
      tel: "",
      sdworker: {
        Name: "",
        Tel: "",
      },
      count: 0,
      show: true,
      msShow: false,
      messageText: ""
    };
  },
  created() {},
  methods: {
    Search() {
      var that = this;
      that.$http
        .get("SDWorker/GetSDWorkerByTel3", {
          params: { sdworkerTel: that.tel },
        })
        .then((res) => {
          if (res.data.Msg == "success") {
            that.sdworker = res.data.Data.sdworker;
            that.count = res.data.Data.count;
            if (that.count >= 2) {
              that.show = !that.show;
            } else {
              that.messageText = res.data;
              that.msShow = true;
            }
          } else {
            that.$toast(res.data);
          }
        });
    },
    CreateInvite() {
      var that = this;
      that.$http
        .get("Team/CreateInvite", {
          params: { sdworkerTel: that.tel, type: 1 },
        })
        .then((res) => {
          if (res.data == "success") {
            that.$toast("邀请好友申请已提交，请等待好友通过！");
            that.$router.back(-1);
          } else {
            that.$toast(res.data);
          }
        });
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Search.name]: Search,
    [Button.name]: Button,
    [Form.name]: Form,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
  },
};
</script>
<style scoped>
html {
  background: #f12416;
}
#page {
  width: 100%;
  height: 100%;
}
.indexPage {
  width: 100%;
  height: 100%;
  background-image: url("../assets/draw3/index.jpg");

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-content: space-around;
  justify-content: center;
  flex-wrap: wrap;
}
.mockTap {
  width: 280px;
  height: 280px;
  padding-top: 70px;
}
.step {
  z-index: 999;
}

.bounce-in-top {
  -webkit-animation: bounce-in-top 1.2s ease-in both;
  animation: bounce-in-top 1.2s ease-in both;
}
/* ----------------------------------------------
 * Generated by Animista on 2021-9-5 1:36:2
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation bounce-in-top
 * ----------------------------------------
 */
@-webkit-keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
@keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}

.balance-text {
  margin-top: 0;
  font-size: 13px;
}
.balance-name {
  color: #666;
  margin-top: 5px;
}
.balance-value {
  font-size: 13px;
  font-weight: bold;
  margin-top: 5px;
  color: #b00;
}
</style>
